import { Button, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Stack, Typography } from "@mui/material"
import StepperDUC from "./StepperDUC"
import { Controller, ControllerRenderProps, useForm } from "react-hook-form"
import { LassoFormField } from "../../components/form/LassoFormField"
import { useState } from "react"

interface FormValues {
    publication: string,
    identified: string,
    DOI: string,
    pubmed: string
}

const Renewal = (props: any) => {
    const [disable, setDisable] = useState(true)

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm<FormValues>({
        defaultValues: {
            publication: "",
            identified: "",
            DOI: props?.DUCInfo?.DOI || "",
            pubmed: props?.DUCInfo?.pubmed || ""
        },
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, field: ControllerRenderProps<FormValues, "publication">) => {
        if(event.target.value === "Yes"){
            setDisable(false)
        }
        else{
            setDisable(true)
            setValue('identified', "")
        }
        field.onChange(event)
    }

    const handleClick = (newData: FormValues) => {
        props.setDUCInfo({ ...props.DUCInfo, ...newData })
        props.setCurStep(props.curStep + 1)
    }

    const handleClickBack = () => {
        props.setCurStep(props.curStep - 1)
    }

    const validateWordCount = (value: string) => {
        const wordCount = value.trim().split(/\s+/).length;
        return wordCount <= 50 || "The Pubmed cannot exceed 50 words";
    };
    
    return (
        <>
            <Stack gap={3}>
                <Stack flexDirection="column" gap={4}>
                    <StepperDUC
                        activeStep={props.curStep}
                        stepLabels={props.stepLabels} />
                </Stack>

                <Typography variant="h6" fontWeight="600">
                        Renewal
                </Typography>

                <Typography>
                Researchers who conduct a secondary analysis on shared data, are expected as part of theTerms of Use 
                (above) to report their results (See #12 in the general DUC).
                </Typography>

                <Stack
                    flexDirection="column">
                    <Typography>
                        Has a publication, computational pipeline, or other public disclosure of results from the analysis of data accessed from 
                        NIH Brain Development Cohorts resulted from a Recipient’s previous access period? Note 
                        that publication includes preprint services (e.g., PsyArXiv, BioRxiv).
                    </Typography>

                    <FormControl error={!!errors.publication}>
                        <Controller                            
                            rules={{ required: "This is a required field" }}
                            control={control}
                            name="publication"
                            render={({ field }) =>(
                                <RadioGroup
                                    {...field}
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    onChange={(e) => handleChange(e,field)}>
                                    <Stack flexDirection="row">
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </Stack>
                                </RadioGroup>)}/>
                        {errors.publication && <FormHelperText>{errors.publication.message}</FormHelperText>}
                    </FormControl>
                </Stack>

                <Stack
                    flexDirection="column">
                    <Typography>
                        If Yes, has the derived data used in disclosure of results been identified?
                    </Typography>

                    <FormControl>
                        <Controller                            
                            control={control}
                            name="identified"
                            render={({ field }) =>(
                                <RadioGroup
                                    {...field}
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group">
                                    <Stack flexDirection="row">
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" disabled={disable}/>
                                        <FormControlLabel value="No" control={<Radio />} label="No" disabled={disable}/>
                                    </Stack>
                                </RadioGroup>)}/>
                    </FormControl>
                </Stack>

                <Stack
                    flexDirection="column"
                    gap={5}> 

                    <LassoFormField
                        label = "List the DOI(s)" 
                        controller={{
                            name: "DOI",
                            control: control,
                            rules: { required: "The DOI(s) are required", pattern: /^(?!\s*$).+/,  maxLength: {
                                value: 70,
                                message: "Max character limit is 70" } }

                        }}
                        fullWidth
                        required
                        error={errors.DOI}
                        marginTop ={10}
                        helperText={errors?.DOI?.message || ""}
                    />

                    <LassoFormField
                        label= "List the PubMed ID(s) or citation(s)"
                        controller={{
                            name: "pubmed",
                            control: control,
                            rules: { required: "PubMed Id(s) or citation(s) are required", pattern: /^(?!\s*$).+/,
                                validate: validateWordCount }
                        }}
                        fullWidth
                        required
                        marginTop ={10}
                        error={errors.pubmed}
                        helperText={errors?.pubmed?.message || ""}
                    />
                </Stack>

                <Stack
                    flexDirection="row"
                    justifyContent="space-between">

                    <Button
                        variant="tertiary"
                        onClick={handleClickBack}
                        sx={{ alignSelf: "center" }}
                    >
                        Back
                    </Button>

                    <Button
                        variant="primary"
                        onClick={handleSubmit(handleClick)}
                        sx={{ alignSelf: "center", marginTop: 3 }}
                    >
                        Continue
                    </Button>

                </Stack>

            </Stack>
        </>
    )
}

export default Renewal